import { habilitationOrgMatchExpr } from '../workflow'

async function findData(context, callback) {
    const alertCollectionName = global.app.S.Alert.collectionName
    const habilitationCollectionName = global.app.S.Habilitation.collectionName
    const alertPromise = global.app.S.StaticWorkflow.collection.aggregate([
        {
            $match: {
                group: new global.ObjectID(context.group.id),
                step: { $nin: ['risk', 'noRisk'] }
            }
        },
        {
            $lookup: {
                from: alertCollectionName,
                    localField: 'alert',
                    foreignField: '_id',
                    as: 'alertDetails'
            }
        },
        { $unwind: '$alertDetails' },
        {
            $match: {
                'alertDetails.workflow.step': { $nin: ['risk', 'noRisk'] }
            }
        },
        {
            $lookup: {
                from: habilitationCollectionName,
                let: {
                    habFunctionId: '$habFunction',
                    alertStore: '$alertDetails.store',
                    alertOrganizations: '$alertDetails.organizations'
                },
                pipeline: [
                    {
                        $match: {
                            $expr: {
                                $and: [
                                    { $eq: ['$habFunction', '$$habFunctionId'] },
                                    { $eq: ['$user', new global.ObjectID(context.user.id)] },
                                    habilitationOrgMatchExpr('$$alertStore', '$$alertOrganizations')
                                ]
                            }
                        }
                    }
                ],
                as: 'hab'
            }
        },
        {
            $match: {
                'hab.0': { $exists: true }
            }
        },
        {
            $group: {
                _id: '$alert'
            }
        }
    ]).toArray()

    const [alerts] = await Promise.all([alertPromise])

    return [
        {
            id: "000000000000000000000001",
            data: alerts.length
        }
    ]
}

export const entity = {
    name: 'CurrentUserAlertsInProgress',
    dashboard: true,
    fields: ["id", "subTitle", "data"],
    find: function(context, callback) {
        this.prepareContext(context, 'L', (error, context) => {
            if (error) callback(error)
            else
                findData(context)
                    .then(objects => callback(null, objects))
                    .catch(error => callback(error))
        })
    }
}